module.exports = __webpack_public_path__ + "media/assets/images/solutions/smart_working/hero_image-01a73692f2103db7d7a54dee10f98bce.png";